package com.playoffpulse.frontend.ui

private data class TeamTileColors(
    val primary: String,
    val secondary: String,
    val text: String = "#f5fbff",
)

object TeamTilePalette {
    private val fallback = TeamTileColors("#1b3556", "#29f3ff", "#f5fbff")

    private val byTeamId = mapOf(
        "ANA" to TeamTileColors("#f47a38", "#b9975b", "#0b1118"),
        "BOS" to TeamTileColors("#ffb81c", "#000000", "#081119"),
        "BUF" to TeamTileColors("#003087", "#ffb81c"),
        "CGY" to TeamTileColors("#c8102e", "#f1be48"),
        "CAR" to TeamTileColors("#cc0000", "#111111"),
        "CHI" to TeamTileColors("#cf0a2c", "#111111"),
        "COL" to TeamTileColors("#6f263d", "#236192"),
        "CBJ" to TeamTileColors("#002654", "#ce1126"),
        "DAL" to TeamTileColors("#006847", "#8f8f8c"),
        "DET" to TeamTileColors("#ce1126", "#ffffff"),
        "EDM" to TeamTileColors("#041e42", "#ff4c00"),
        "FLA" to TeamTileColors("#041e42", "#c8102e"),
        "LAK" to TeamTileColors("#111111", "#a2aaad"),
        "MIN" to TeamTileColors("#154734", "#ddcba4"),
        "MTL" to TeamTileColors("#af1e2d", "#192168"),
        "NSH" to TeamTileColors("#ffb81c", "#041e42", "#07111c"),
        "NJD" to TeamTileColors("#ce1126", "#111111"),
        "NYI" to TeamTileColors("#00539b", "#f47d30"),
        "NYR" to TeamTileColors("#0038a8", "#ce1126"),
        "OTT" to TeamTileColors("#c52032", "#c2912c"),
        "PHI" to TeamTileColors("#f74902", "#111111"),
        "PIT" to TeamTileColors("#ffb81c", "#111111", "#07111c"),
        "SJS" to TeamTileColors("#006d75", "#111111"),
        "SEA" to TeamTileColors("#001628", "#99d9d9"),
        "STL" to TeamTileColors("#002f87", "#f1be48"),
        "TBL" to TeamTileColors("#002868", "#ffffff"),
        "TOR" to TeamTileColors("#00205b", "#ffffff"),
        "UTA" to TeamTileColors("#6ca3d9", "#111111", "#07111c"),
        "VAN" to TeamTileColors("#00843d", "#00205b"),
        "VGK" to TeamTileColors("#b4975a", "#333f48", "#07111c"),
        "WSH" to TeamTileColors("#041e42", "#c8102e"),
        "WPG" to TeamTileColors("#041e42", "#7bafd4"),
    )

    fun inlineStyle(teamId: String): String {
        val colors = byTeamId[teamId.uppercase()] ?: fallback
        return "--team-primary:${colors.primary}; --team-secondary:${colors.secondary}; --team-text:${colors.text};"
    }

    fun logoUrl(teamId: String): String {
        return "https://assets.nhle.com/logos/nhl/svg/${teamId.uppercase()}_light.svg"
    }
}
